import type { Client, RequestContext } from "../client";
import type { CreateSupportRequestCommand, CreateSupportRequestResponse, UploadSupportFileResponse } from "../resources/supportRequestResource";
export class SupportRepository {
    constructor(private client: Client, private requestContext: RequestContext) { }
    async uploadSupportFile(file: File): Promise<UploadSupportFileResponse> {
        const formData = new FormData();
        formData.append("File", file);
        return this.client.post<UploadSupportFileResponse>(this.requestContext, "~/api/support/file", formData);
    }
    async createSupportRequest(command: CreateSupportRequestCommand): Promise<CreateSupportRequestResponse> {
        return this.client.post<CreateSupportRequestResponse>(this.requestContext, "~/api/supportrequest", command);
    }
}
